/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MainLeaks
 */
export interface MainLeaks {
}

/**
 * Check if a given object implements the MainLeaks interface.
 */
export function instanceOfMainLeaks(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MainLeaksFromJSON(json: any): MainLeaks {
    return MainLeaksFromJSONTyped(json, false);
}

export function MainLeaksFromJSONTyped(json: any, ignoreDiscriminator: boolean): MainLeaks {
    return json;
}

export function MainLeaksToJSON(value?: MainLeaks | null): any {
    return value;
}

